import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InfoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"info"}/>
}
